import React from "react";

const VisionMissionQualitySection = () => {
  return (
    <section className="w-full bg-[#112E65] py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-center text-4xl font-bold text-white mb-12">
          Our Core Foundations
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Vision */}
          <div className="relative bg-white text-[#112E65] p-8 rounded-tl-[40px] rounded-br-[40px] shadow-lg transition-transform duration-300 hover:-translate-y-2">
            <span className="absolute -top-4 left-6 bg-[#112E65] text-white px-4 py-1 rounded-full text-sm">
              Vision
            </span>
            <h3 className="text-2xl font-semibold mt-6 mb-4">Our Vision</h3>
            <p className="text-base leading-relaxed">
              To develop globally competent pharmacists equipped with cognitive, technical, and ethical skills, ready to advance the healthcare and pharmaceutical industries.
            </p>
          </div>

          {/* Mission */}
          <div className="relative bg-white text-[#112E65] p-8 rounded-tr-[40px] rounded-bl-[40px] shadow-lg transition-transform duration-300 hover:-translate-y-2">
            <span className="absolute -top-4 left-6 bg-[#112E65] text-white px-4 py-1 rounded-full text-sm">
              Mission
            </span>
            <h3 className="text-2xl font-semibold mt-6 mb-4">Our Mission</h3>
            <p className="text-base leading-relaxed">
              To establish a world-class learning environment with modern infrastructure.
To deliver student-centric education promoting innovation & entrepreneurship.
To strengthen the industry–academia relationship for skill development.
To instill social responsibility, compassion & lifelong learning.
            </p>
          </div>

          {/* Values */}
          <div className="relative bg-white text-[#112E65] p-8 rounded-tl-[40px] rounded-br-[40px] shadow-lg transition-transform duration-300 hover:-translate-y-2">
            <span className="absolute -top-4 left-6 bg-[#112E65] text-white px-4 py-1 rounded-full text-sm">
              Values
            </span>
            <h3 className="text-2xl font-semibold mt-6 mb-4">Our Values</h3>
            <p className="text-base leading-relaxed">
             Commitment to excellence in education & research.
Integrity, ethics & professionalism.
Teamwork, respect & inclusiveness.
Reliable, disciplined & compassionate service mindset.
            </p>
          </div>

          {/* Motto */}
          <div className="relative bg-white text-[#112E65] p-8 rounded-tr-[40px] rounded-bl-[40px] shadow-lg transition-transform duration-300 hover:-translate-y-2">
            <span className="absolute -top-4 left-6 bg-[#112E65] text-white px-4 py-1 rounded-full text-sm">
              Motto
            </span>
            <h3 className="text-2xl font-semibold mt-6 mb-4">Our Motto</h3>
            <p className="text-base leading-relaxed font-medium">
             हस्ते विभ्रद्रेषजा <br/>
“A pharmacist has the divine ability to create life-healing medicines.”
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionMissionQualitySection;
